module.exports = __webpack_public_path__ + "static/media/avatar.5fe10ff9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar.jpg
// module id = 35
// module chunks = 0